import mdcAutoInit from '@material/auto-init';

const mdcRegistry = {};
const registerMdcComponent = (name, Constructor) => {
  mdcRegistry[name] = Constructor;
  mdcAutoInit.register(name, Constructor);
};

import {MDCTextField} from '@material/textfield';
registerMdcComponent('MDCTextField', MDCTextField);

import {MDCTabBar} from '@material/tab-bar';
registerMdcComponent('MDCTabBar', MDCTabBar);

import {MDCChipSet} from '@material/chips';
registerMdcComponent('MDCChipSet', MDCChipSet);

import {MDCChip} from '@material/chips';
registerMdcComponent('MDCChip', MDCChip);

import {MDCSelect} from '@material/select';
import {Corner} from '@material/menu-surface/constants';
registerMdcComponent('MDCSelect', MDCSelect);

import {MDCSwitch} from '@material/switch';
registerMdcComponent('MDCSwitch', MDCSwitch);

import {MDCCheckbox} from '@material/checkbox';
registerMdcComponent('MDCCheckbox', MDCCheckbox);
  
import {MDCList} from '@material/list';
registerMdcComponent('MDCList', MDCList);

import {MDCRipple} from '@material/ripple';
registerMdcComponent('MDCRipple', MDCRipple);

import {MDCFormField} from '@material/form-field';
registerMdcComponent('MDCFormField', MDCFormField);

import {MDCRadio} from '@material/radio';
registerMdcComponent('MDCRadio', MDCRadio);

import {MDCMenu} from '@material/menu';
registerMdcComponent('MDCMenu', MDCMenu);

import {MDCMenuSurface} from '@material/menu-surface';
registerMdcComponent('MDCMenuSurface', MDCMenuSurface);

import {MDCSlider} from '@material/slider';
registerMdcComponent('MDCSlider', MDCSlider);

import {MDCDialog} from '@material/dialog';
// Dialogs are created explicitly by Stimulus controllers; keep them out of
// global auto-init to avoid re-initializing hidden/shared shells.


import {MDCSegmentedButton} from '@material/segmented-button';
registerMdcComponent('MDCSegmentedButton', MDCSegmentedButton);

// import {MDCNotchedOutline} from '@material/notched-outline';
// mdcAutoInit.register('MDCNotchedOutline', MDCNotchedOutline);

import {MDCBanner} from '@material/banner';
registerMdcComponent('MDCBanner', MDCBanner);

import {MDCTooltip} from '@material/tooltip';
registerMdcComponent('MDCTooltip', MDCTooltip);

import {MDCSnackbar} from '@material/snackbar';
registerMdcComponent('MDCSnackbar', MDCSnackbar);

import {MDCCircularProgress} from '@material/circular-progress';
registerMdcComponent('MDCCircularProgress', MDCCircularProgress);

const AUTO_INIT_SELECTOR = '[data-mdc-auto-init]';

const queryWithinRoot = (rootNode, selector) => {
  const nodes = [];

  if (rootNode instanceof Element && rootNode.matches(selector)) {
    nodes.push(rootNode);
  }

  if (rootNode && rootNode.querySelectorAll) {
    nodes.push(...rootNode.querySelectorAll(selector));
  }

  return nodes;
};

const hasValidMdcStructure = (node, ctorName) => {
  if (ctorName === 'MDCSelect') {
    const anchor = node.querySelector('.mdc-select__anchor');
    const selectedText = node.querySelector('.mdc-select__selected-text');
    const menu = node.querySelector('.mdc-select__menu.mdc-menu.mdc-menu-surface');
    const list = menu != null ? menu.querySelector('.mdc-list') : null;

    return anchor != null && selectedText != null && menu != null && list != null;
  }

  return true;
};

const bindSlider = (sliderEl) => {
  const slider = sliderEl.MDCSlider;
  if (slider == null) return;

  const input = sliderEl.querySelector('input');
  const actual = sliderEl.closest('[data-slider-metric="true"]')?.querySelector('[data-slider-actual]');
  if (input != null) {
    slider.value = input.value === "" ? 0 : input.value;
  }

  if (sliderEl.dataset.mdcSliderChangeBound === 'true') return;

  slider.listen('MDCSlider:change', () => {
    if (input == null) return;

    input.value = slider.value;
    if (actual) actual.value = input.value;
    input.dispatchEvent(new Event('change'));

    if (input.closest('form') !== null) {
      input.closest('form').dispatchEvent(new Event('change'));
    }
  });

  if (actual && input) {
    actual.addEventListener('input', () => {
      slider.value = Math.min(slider.max, Math.max(slider.min, Number(actual.value)));
      input.value = actual.value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    actual.closest('form')?.addEventListener('reset', () => {
      requestAnimationFrame(() => {
        slider.value = Math.min(slider.max, Math.max(slider.min, Number(input.value)));
      });
    });
  }

  sliderEl.dataset.mdcSliderChangeBound = 'true';
};

const bindSegmentedButton = (segButtonEl) => {
  const segButton = segButtonEl.MDCSegmentedButton;
  const input = segButtonEl.querySelector('input');
  if (segButton == null || input == null) return;

  segButton.segments.forEach((seg) => {
    if (seg.root.dataset.value == input.value) {
      seg.setSelected();
    }
  });

  if (segButtonEl.dataset.mdcSegmentedButtonBound === 'true') return;

  segButton.segments.forEach((segment) => {
    segment.listen('selected', () => {
      segment.setSelected();
      input.value = segment.root.dataset.value;
      input.dispatchEvent(new Event('change'));

      segButton.segments.forEach((seg) => {
        if (seg.index != segment.index) {
          seg.setUnselected();
        }
      });
    });
  });

  segButtonEl.dataset.mdcSegmentedButtonBound = 'true';
};

const bindPlainSelect = (selectEl) => {
  if (selectEl.getAttribute('listener4Input') === 'true') return;

  const select = selectEl.MDCSelect;
  const input = selectEl.querySelector('input');
  if (select == null) return;

  if (selectEl.closest('.mdc-data-table') !== null) {
    const menuSurface = select.menu && select.menu.menuSurface_ ? select.menu.menuSurface_ : null;
    const anchorEl = selectEl.querySelector('.mdc-select__anchor');

    if (menuSurface != null && anchorEl != null) {
      menuSurface.setIsHoisted(true);
      menuSurface.setFixedPosition(true);
      menuSurface.setMenuSurfaceAnchorElement(anchorEl);
      menuSurface.setAnchorCorner(Corner.BOTTOM_START);
      menuSurface.root.style.zIndex = '21000';

      if (menuSurface.root.parentElement !== document.body) {
        document.body.appendChild(menuSurface.root);
      }
    }
  }

  if (input !== null) {
    select.value = input.dataset.mdcSelectValue || input.value;
  }

  select.layout?.();
  select.layoutOptions?.();

  select.listen('MDCSelect:change', () => {
    if (input === null) return;

    input.value = select.value === input.dataset.mdcBlankValue ? "" : select.value;
    input.dispatchEvent(new Event('change'));

    if (input.closest('form') !== null) {
      input.closest('form').dispatchEvent(new Event('change'));
    }
  });

  selectEl.setAttribute('listener4Input', 'true');
};

const toggleExtraSelectInput = (selectEl, selectedValue, expandedValue) => {
  const inputs = selectEl.querySelectorAll('input');
  if (inputs.length === 0) return;

  const extraInput = inputs[inputs.length - 1];
  const extraWrapper = extraInput.parentElement;
  if (extraWrapper == null) return;

  if ((selectedValue || '').toLowerCase() === expandedValue) {
    extraWrapper.style.display = 'block';
    extraInput.value = "";
    setTimeout(() => extraInput.focus(), 200);
  } else {
    extraWrapper.style.display = 'none';
  }
};

const bindCompositeSelect = (selectEl, selector, emptyFallbackValue, expandedValue) => {
  if (selectEl.getAttribute('listener4Input') === 'true') return;

  const selectElement = selectEl.querySelector(selector);
  const select = selectElement != null ? selectElement.MDCSelect : null;
  const input = selectEl.querySelector('input');

  if (select == null) return;

  if (input !== null) {
    select.value = input.value;
  }

  if (input !== null && input.value.length > 0 && select.value == "") {
    select.value = emptyFallbackValue;
  }

  select.layout?.();
  select.layoutOptions?.();

  toggleExtraSelectInput(selectEl, select.value, expandedValue);

  select.listen('MDCSelect:change', (event) => {
    if (event.target.querySelector('input') !== null) {
      selectEl.querySelectorAll('input').forEach((el) => { el.value = select.value; });
    }

    toggleExtraSelectInput(selectEl, select.value, expandedValue);
  });

  selectEl.setAttribute('listener4Input', 'true');
};

const initializeMdcBehaviors = (rootNode) => {
  queryWithinRoot(rootNode, '.mdc-banner').forEach((bannerEl) => {
    const banner = bannerEl.MDCBanner;
    if (banner != null && !banner.isOpen) {
      banner.open();
    }
  });

  queryWithinRoot(rootNode, '.mdc-slider').forEach(bindSlider);
  queryWithinRoot(rootNode, '.mdc-segmented-button').forEach(bindSegmentedButton);
  queryWithinRoot(rootNode, '.mdc-select:not(.mdc-select-other):not(.mdc-select-yes-no)').forEach(bindPlainSelect);
  queryWithinRoot(rootNode, '.select-other').forEach((selectEl) => {
    bindCompositeSelect(selectEl, '.mdc-select.mdc-select-other', 'Other', 'other');
  });
  queryWithinRoot(rootNode, '.select-yes-no').forEach((selectEl) => {
    bindCompositeSelect(selectEl, '.mdc-select.mdc-select-yes-no', 'yes', 'yes');
  });
};

window.mdcAutoInit = function (root = document) {
  const rootNode = root || document;
  const nodes = queryWithinRoot(rootNode, AUTO_INIT_SELECTOR);
  const initialized = [];

  nodes.forEach((node) => {
    const ctorName = node.getAttribute('data-mdc-auto-init');
    const Constructor = mdcRegistry[ctorName];

    if (typeof Constructor !== 'function') return;
    if (!hasValidMdcStructure(node, ctorName)) return;

    if (node.getAttribute('data-mdc-auto-init-state') === 'initialized' || node[ctorName]) {
      node.setAttribute('data-mdc-auto-init-state', 'initialized');
      return;
    }

    try {
      const component = Constructor.attachTo(node);

      Object.defineProperty(node, ctorName, {
        configurable: true,
        enumerable: false,
        value: component,
        writable: false,
      });

      node.setAttribute('data-mdc-auto-init-state', 'initialized');
      initialized.push(component);
    } catch (error) {
      console.error('MDC auto-init failed for', node, error);
    }
  });

  initializeMdcBehaviors(rootNode);
  document.dispatchEvent(new CustomEvent('MDCAutoInit:End', {
    bubbles: false,
    detail: { root: rootNode, initialized },
  }));
  return initialized;
};

window.addEventListener('DOMContentLoaded', (event) => {
  window.mdcAutoInit(document);
});
